import { useMemo } from 'react';
import React from 'react';
import { LayoutProviderProps } from './LayoutContext';
import { LayoutProvider } from './LayoutContext';
import styles from './LayoutEmbed.module.scss';

export const LayoutEmbed: React.FC = ({ children }) => {
    const layoutParams = useMemo<LayoutProviderProps['initialValues']>(
        () => ({
            embedded: true,
        }),
        []
    );

    return (
        <LayoutProvider initialValues={layoutParams}>
            <div className={styles.wrapper}>{children}</div>
        </LayoutProvider>
    );
};
